import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CompanyContext } from '../../../Contexts/CompanyContext';
import { GetCompany, GetTenants, ShowTenant } from '../../../API/CompaniesAPI';
import { IResponseProps } from '../../../Interfaces/IResponseProps';
import { toast } from 'react-toastify';
import { TenantModel } from '../../../Models/TenantModel';
import { AuthContext } from '../../../Contexts/AuthContext';
import { useAuth } from 'oidc-react';
import { SetTenantIdSession, SetTokenSession } from '../../../Utils/StorageSessions';
import { api, CommonHeaderProperties } from '../../../Configurations/axios';
import CardTitleCustom from '../../components/card/title';
import { AutoComplete, AutoCompleteProps, Input, Table, TableColumnsType, TableProps, Typography } from 'antd';


interface DataType {
    name: string;
    action: React.ReactNode
}

const columns: TableColumnsType<DataType> = [
    {
        title: 'Nome da empresa',
        dataIndex: 'name',
        showSorterTooltip: { target: 'full-header' },
        width: '90%'
    }
];

export default function ByPass () {

    let userData = useAuth()?.userData;
    const access_token = userData?.access_token || '';

    const navigate = useNavigate();
    const { isChange } = useParams();
    const { getCompany } = useContext(CompanyContext);
    const { handleLogin } = useContext(AuthContext);

    const [ options, setOptions ] = useState<AutoCompleteProps[ 'options' ]>([]);
    const [ loadingSearch, setLoadingSearch ] = useState<boolean>(false);
    const [ searchText, setSearchText ] = useState<string>("all");
    const [ tenants, setTenants ] = useState<DataType[]>([]);
    const [ token, setToken ] = useState<string>("");
    const [ totalPages, setTotalPages ] = useState<number>(0);

    useEffect(() => {
        SetTokenSession(access_token);
        setToken(access_token);
    }, []);

    useEffect(() => {
        if (token !== "") {
            api.defaults.headers = {
                Authorization: `Bearer ${token}`,
            } as CommonHeaderProperties;
            
            getCompaniesAvailable(1);
        }
    }, [token, searchText]);

    // useEffect(() => {
    //     getCompaniesAvailable(1)

    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [ searchText ])

    const onChange: TableProps<DataType>[ 'onChange' ] = (pagination, filters, sorter, extra) => {
        console.log('params', pagination, filters, sorter, extra);
    };

    const onSelect = (value: string) => {
        console.log('onSelect', value);
    };

    const getCompaniesAvailable = async (page: number) => {
        setLoadingSearch(true)

        try {
            const { data }: IResponseProps = await GetTenants(page, searchText)

            const mappedTenants = data.items.map((d: TenantModel) => {
                return {
                    name: <div onClick={() => goToCompany(d.id)} style={{ width: '100%', height: '100%', cursor: 'pointer' }}>{d.name}</div>,
                    action: <div onClick={() => goToCompany(d.id)} style={{ width: '100%', height: '100%', cursor: 'pointer', textAlign: 'center' }}>
                    </div>
                }
            })

            setTenants(mappedTenants);
            var total = data.totalItems;
            const pages = total / 10;
            const ceilPages = Math.ceil(pages);
            setTotalPages(ceilPages);
        } catch (err: any) {
            // TOAST NOT WORKING
            toast.error(err);
        }

        setLoadingSearch(false)
    }

    const setUser = async (tenantId: string) => {
        try {
            await handleLogin(userData?.profile.email ?? "", tenantId)
        } catch (error: any) {
            toast.error(error);
        }
    }

    const goToCompany = async (id: string) => {
        setLoadingSearch(true)

        try {
            const { data }: IResponseProps = await ShowTenant(id, isChange ? true : false);

            var companyId = data.id;
            setUser(id);
            sessionStorage.removeItem("company");
            sessionStorage.removeItem("tenantId");
            SetTenantIdSession(id);
            getCompany(companyId);
            sessionStorage.setItem("company", JSON.stringify(GetCompany(companyId)));
            navigate(`/home/${companyId}`);

        } catch (error: any) {
            toast.error(error);
            setLoadingSearch(false)
        }
    }

    return (
        <div>
            <div style={{ margin: '16px 0px', width: '100%', display: 'grid', gridTemplateRows: '0.6fr 5fr', rowGap: '16px' }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    {CardTitleCustom({ text: 'Bem Vindo a Seleção de Empresas do Financiamento' })}
                </div>
                <div style={{ background: 'white', borderRadius: '16px', display: 'grid', gridTemplateRows: '0.7fr 6fr', padding: '30px', rowGap: '16px' }}>

                    <div style={{ display: 'grid', gridTemplate: '"a b" auto / 1fr 1fr', alignContent: 'center' }}>
                        <Typography style={{ fontSize: '20px' }}>Selecione a empresa que deseja trabalhar</Typography>
                        <AutoComplete
                            popupMatchSelectWidth={true}
                            style={{ width: '100%', paddingRight: '0px' }}
                            options={options}
                            onSelect={onSelect}
                            onSearch={(val) => { setSearchText(val === '' ? 'all' : val) }}
                        >
                            <Input.Search showCount={false} color='#0000A4' loading={loadingSearch} placeholder="Procurar" enterButton />
                        </AutoComplete>
                    </div>
                    <Table
                        columns={columns}
                        dataSource={tenants}
                        loading={loadingSearch}
                        pagination={{
                            total: totalPages, onChange (page) {
                                getCompaniesAvailable(page)
                            },
                            showSizeChanger: false
                        }}
                        
                        onChange={onChange}
                        showSorterTooltip={{ target: 'sorter-icon' }}
                    />

                </div>
            </div>
        </div>
    )
}